









































































































































































































import { Component, Vue } from "vue-property-decorator";
import axios from "@/axios";

@Component
export default class NewVueComponent extends Vue {
  errors = [];
  showLimit = 20;
  bookings = [];
  bookingStatus = [];
  prices = null;

  get hotelInfo() {
    return this.$store.state.hotelInfo;
  }

  get authUser() {
    return this.$store.state.authProfile;
  }

  get filterBookings() {
    if (!this.bookingStatus.length) return this.bookings;
    return this.bookings.filter(f =>
      this.bookingStatus.includes(f.arrivalData.status)
    );
  }

  close(e) {
    e.preventDefault();
    if (e.target.parentElement) {
      const parent = e.target.closest(".link-narrow");
      parent.classList.add("hidden");
    }
  }

  gotoGuestReg(e, bookingInfo) {
    e.preventDefault();
    if (bookingInfo.guestRegLink) {
      //window.location.href = bookingInfo.guestRegLink;
      window.open(bookingInfo.guestRegLink);
    }
  }

  getAllBookingBasic() {
    const User = this.$store.state.authProfile;
    const Hotel = this.$store.state.hotelInfo;
    const hotelKey = Hotel ? Hotel.hotelKey : localStorage.getItem("hotelKey");
    if (!hotelKey) {
      this.errors.push("No Hotel Info");
    }
    if (hotelKey) {
      const Url = `${process.env.VUE_APP_APIURL}/allbookings/${hotelKey}/${this.showLimit}`;
      const data = { e: User.email ? btoa(User.email) : null };
      axios
        .post(Url, data)
        .then(response => {
          if (response.data) {
            if (response.data.info) {
              if (response.data.info.bookings) {
                this.bookings = response.data.info.bookings;
              }
              if (response.data.info.prices) {
                this.prices = response.data.info.prices;
              }
            }
          }
        })
        .catch(e => {
          this.errors.push(e);
        });
    }
  }

  created() {
    this.getAllBookingBasic();
  }
}
